import { createSlice } from "@reduxjs/toolkit";

import { compareInString } from "../../../container/SportsBookNode/utils/common/functions";
import { initialState } from "./initialState";
import {
  localSportsIds,
  tennisProviderSportId
} from "../../../container/SportsBookNode/utils/common/constants";

const SportBookSlice = createSlice({
  name: "SportBook",
  initialState,
  reducers: {
    getSportsStart: (state, action) => {
      state.loading = true;
      state.error = false;
    },
    getSportsSuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.sports = action?.payload;
      state.localSports = action?.payload
        ?.filter((sport) => {
          return localSportsIds.includes(sport?.providerSportId);
        })
        ?.sort((a, b) => {
          return (
            localSportsIds.indexOf(a.providerSportId) -
            localSportsIds.indexOf(b.providerSportId)
          );
        });
      state.topSports = action?.payload?.filter((sport) => {
        return sport?.isTop;
      });
    },
    getSportsFailure: (state) => {
      state.loading = false;
      state.error = true;
    },
    getCountriesStart: (state, action) => {
      state.isCountryLoading = true;
      state.error = false;
    },
    getCountriesSuccess: (state, action) => {
      state.isCountryLoading = false;
      state.success = true;
      state.topCountry =
        action?.payload?.data?.filter((country) => country?.isTop) || [];

      state.countries = [...(action?.payload?.data || [])];
    },
    getCountriesFailure: (state) => {
      state.isCountryLoading = false;
      state.error = true;
    },
    updateSelectedSport: (state, action) => {
      state.selectedSportId = action?.payload?.selectedSportId;
      state.selectedSportName = action?.payload?.selectedSportName;
      state.selectedSportImg = action?.payload?.selectedSportImg;
      state.selectedCountryId = action?.payload?.countryId;
      state.selectedLeagueId = action?.payload?.tournamentId;
      state.selectedFeedProvider = action?.payload?.selectedFeedProvider;
    },
    setSearchMatchName: (state, action) => {
      state.search = action?.payload;
    },
    getSportBookBannersStart: (state, action) => {
      state.bannerLoading = true;
    },
    getSportBookBannersSuccess: (state, action) => {
      state.bannerLoading = false;
      state.lobbyBannerList = action?.payload;
    },
    getSportBookBannersFailure: (state, action) => {
      state.bannerLoading = false;
      state.error = true;
    },
    setSelectedOddsFormat: (state, action) => {
      state.selectedOddsFormat = action.payload;
    },
    getLeaguesStart(state, action) {
      state.leaguesLoading = true;
    },
    getLeaguesSuccess(state, action) {
      const selectedTournamentId = action?.payload?.leagueId;
      if (selectedTournamentId) {
        const leaguesArray = action?.payload?.data || [];
        const orderedLeague = leaguesArray?.reduce((accumulator, current) => {
          if (compareInString(current.tournamentId, selectedTournamentId)) {
            accumulator?.unshift(current);
          } else {
            accumulator?.push(current);
          }
          return accumulator;
        }, []);
        state.leagues = orderedLeague;
      } else {
        state.leagues = action?.payload?.data;
        state.leaguesLoading = false;
      }
    },
    getLeaguesFailure(state) {
      state.error = true;
      state.leaguesLoading = false;
    },
    resetLeagues(state) {
      state.leagues = initialState.leagues;
    },
    resetCountries(state) {
      state.countries = initialState.countries;
    },
    getTopLeaguesStart(state, action) {
      state.topLeaguesLoading = true;
      state.topLeagueSport = action.payload;
    },
    getTopLeaguesSuccess(state, action) {
      const tennisData = state.sports.find((sportsData) => {
        return compareInString(
          sportsData?.providerSportId,
          tennisProviderSportId
        );
      });

      if (compareInString(tennisData?.sportId, state.topLeagueSport?.sportId)) {
        state.tennisTopleagues = action?.payload;
        if (!state.topLeagueSport?.topLeagueSelectedSport) {
          state.topleagues = action?.payload;
        }
        state.topLeaguesLoading = false;
      } else {
        state.topleagues = action?.payload;
        state.topLeaguesLoading = false;
      }
    },
    getTopLeaguesFailure(state) {
      state.error = true;
      state.topLeaguesLoading = false;
    },
    setSelectedTopSports(state, action) {
      state.selectedTopSport = action?.payload;
    },
    setSearchEnable(state, action) {
      state.searchEnable = action.payload;
    },
    getPopularCountriesStart(state, action) {
      state.popularCountryLoading = false;
    },
    getPopularCountriesSuccess(state, action) {
      state.popularCountryLoading = true;
      state.popularCountryData = action.payload;
    },
    getPopularCountriesFailure(state, action) {
      state.popularCountryLoading = false;
    },
    setSelectedCountryId(state, action) {
      state.selectedCountryId = action.payload;
    },
    setSelectedLeagueId(state, action) {
      state.selectedLeagueId = action.payload;
    }
  }
});

export const {
  setSelectedCountryId,
  setSelectedLeagueId,
  getTopLeaguesStart,
  getTopLeaguesSuccess,
  getTopLeaguesFailure,
  setSelectedTopSports,
  setSelectedOddsFormat,
  getSportsStart,
  getSportsSuccess,
  getSportsFailure,
  getCountriesStart,
  getCountriesSuccess,
  getCountriesFailure,
  updateSelectedSport,
  setSearchMatchName,
  getSportBookBannersStart,
  getSportBookBannersSuccess,
  getSportBookBannersFailure,
  getLeaguesStart,
  getLeaguesSuccess,
  getLeaguesFailure,
  setSearchEnable,
  resetLeagues,
  getPopularCountriesStart,
  getPopularCountriesSuccess,
  getPopularCountriesFailure,
  resetCountries
} = SportBookSlice.actions;

export default SportBookSlice.reducer;
